import React from 'react';

export default function AccessSharingMenuIcon({
  stroke,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="ic_menu_access_sharing"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={props.width ?? '24'}
      height={props.height ?? '24'}
      {...props}
    >
      <rect id="BG" width="24" height="24" fill="none" />
      <g id="icon" transform="translate(2 2.994)">
        <g id="Person" transform="translate(5.967 2.636)">
          <g
            id="Rectangle_315"
            data-name="Rectangle 315"
            transform="translate(0 8.358)"
            fill="none"
            stroke="#909090"
            strokeWidth="1.2"
          >
            <path
              d="M3,0h8.033a3,3,0,0,1,3,3V7.016a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3A3,3,0,0,1,3,0Z"
              stroke="none"
            />
            <path
              d="M3,.6h8.033a2.4,2.4,0,0,1,2.4,2.4V5.816a.6.6,0,0,1-.6.6H1.2a.6.6,0,0,1-.6-.6V3A2.4,2.4,0,0,1,3,.6Z"
              fill="none"
            />
          </g>
          <path
            id="Path_1103"
            data-name="Path 1103"
            d="M22522-5571.061h0a.217.217,0,0,0-.068-.006h-.145a3.8,3.8,0,0,1-2.6-1.106,3.613,3.613,0,0,1-1.037-2.546,3.666,3.666,0,0,1,3.664-3.659,3.663,3.663,0,0,1,3.658,3.659,3.667,3.667,0,0,1-3.477,3.658Zm-.168-1.32h0a.388.388,0,0,1,.043,0h.008l.035,0,.02.006.021-.006a2.367,2.367,0,0,0,2.223-2.351,2.362,2.362,0,0,0-2.363-2.357,2.358,2.358,0,0,0-2.355,2.357,2.347,2.347,0,0,0,2.262,2.351l.1.006.006-.012Z"
            transform="translate(-22514.797 5578.378)"
            fill={stroke ?? '#909090'}
          />
        </g>
        <g id="Person-2" data-name="Person">
          <path
            id="Path_1105"
            data-name="Path 1105"
            d="M23264.779-5381.905h-.184a2.69,2.69,0,0,1-2.6-2.675,2.692,2.692,0,0,1,2.682-2.691,2.687,2.687,0,0,1,2.688,2.681,2.679,2.679,0,0,1-2.582,2.686Zm-.072-.992c.037,0,.057.006.072.006h.025l.016,0h.021a1.686,1.686,0,0,0,1.555-1.7,1.694,1.694,0,0,0-1.7-1.688,1.689,1.689,0,0,0-1.687,1.688,1.7,1.7,0,0,0,1.6,1.7h.049v-.011Z"
            transform="translate(-23259.313 5387.271)"
            fill={stroke ?? '#909090'}
          />
          <path
            id="Path_1104"
            data-name="Path 1104"
            d="M23154.357-5308.648h4.422s.783.042.77-.6-.77-.552-.77-.552h-3.273v-1.082a1.715,1.715,0,0,1,1.715-1.714h3.736a.571.571,0,0,0,.459-.593.512.512,0,0,0-.459-.555h-3.736a2.866,2.866,0,0,0-2.863,2.862v2.229Z"
            transform="translate(-23154.357 5320.157)"
            fill={stroke ?? '#909090'}
          />
        </g>
      </g>
    </svg>
  );
}
